import React, { useEffect } from "react";
import styles from "./style/FBoxContainer.module.scss";
import { MailIcon, PhoneIcon } from "@heroicons/react/solid";
import { useFormat } from "../../hooks/useFormat";

const FBoxContainer = ({ sortedCategories = [], action = () => {} }) => {
  const { ImageExist } = useFormat();

  return (
    <div>
      {sortedCategories.map((topUp, index) => {
        return (
          <div key={index} className="py-4 border-0">
            <div className="grid place-items-center font-semibold text-[22px] pb-7">
              {topUp.categoryId}
            </div>
            <div className="border-0 grid grid-cols-2 xxs:grid-cols-3 lgg:grid-cols-5">
              {topUp.items.map((item, _index) => (
                <div key={_index} className="border-0 grid grid-rows-2 ">
                  <div className="border-0 row-span-1 grid place-items-center">
                    <div
                      className="w-[70px] h-[70px] bg-[#e9e9e9] grid place-items-center rounded-[20px] cursor-pointer"
                      onClick={() => {
                        action(item);
                      }}
                    >
                      <img src={item.iconUrl} className="w-[50px] h-[50px]" />
                    </div>
                  </div>
                  <div className="border-0 row-span-1 text-center text-[5vw] xxs:text-[15px] grid place-items-center">
                    {item.displayName}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FBoxContainer;
